import { AppModel } from "../models/appModel";
import http from "../utils/http";

export const getListApps = () => http.get<AppModel[]>(`${process.env.REACT_APP_URL}apps`);
